export const vitalSignRows = [
  {
    id: 1,
    date: '06/09/2026',
    bp: '123',
    temp: '98',
    hr: '73',
    rr: '84',
    wt: '89',
    ht: '5.6',
    bmi: '57.67'
  },
  {
    id: 2,
    date: '12/08/2026',
    bp: '128',
    temp: '96',
    hr: '67',
    rr: '93',
    wt: '70',
    ht: '6.1',
    bmi: '19.49'
  },
  {
    id: 3,
    date: '08/07/2026',
    bp: '112',
    temp: '93',
    hr: '81',
    rr: '90',
    wt: '58',
    ht: '5.9',
    bmi: '16.33'
  },
  {
    id: 4,
    date: '22/06/2026',
    bp: '118',
    temp: '99',
    hr: '76',
    rr: '82',
    wt: '72',
    ht: '5.8',
    bmi: '22.14'
  },
  {
    id: 5,
    date: '15/06/2026',
    bp: '130',
    temp: '97',
    hr: '79',
    rr: '88',
    wt: '76',
    ht: '5.9',
    bmi: '23.52'
  },
  {
    id: 6,
    date: '01/06/2026',
    bp: '121',
    temp: '98',
    hr: '72',
    rr: '80',
    wt: '69',
    ht: '5.7',
    bmi: '21.63'
  },
  {
    id: 7,
    date: '19/05/2026',
    bp: '126',
    temp: '99',
    hr: '75',
    rr: '86',
    wt: '74',
    ht: '6.0',
    bmi: '22.10'
  },
  {
    id: 8,
    date: '05/05/2026',
    bp: '117',
    temp: '97',
    hr: '68',
    rr: '81',
    wt: '66',
    ht: '5.5',
    bmi: '23.96'
  },
  {
    id: 9,
    date: '21/04/2026',
    bp: '132',
    temp: '98',
    hr: '83',
    rr: '91',
    wt: '82',
    ht: '6.0',
    bmi: '24.52'
  },
  {
    id: 10,
    date: '07/04/2026',
    bp: '115',
    temp: '96',
    hr: '69',
    rr: '79',
    wt: '64',
    ht: '5.6',
    bmi: '22.76'
  },
  {
    id: 11,
    date: '24/03/2026',
    bp: '124',
    temp: '98',
    hr: '74',
    rr: '85',
    wt: '71',
    ht: '5.8',
    bmi: '21.86'
  },
  {
    id: 12,
    date: '10/03/2026',
    bp: '129',
    temp: '99',
    hr: '77',
    rr: '87',
    wt: '77',
    ht: '6.1',
    bmi: '22.80'
  },
  {
    id: 13,
    date: '26/02/2026',
    bp: '119',
    temp: '97',
    hr: '71',
    rr: '83',
    wt: '68',
    ht: '5.7',
    bmi: '21.11'
  },
  {
    id: 14,
    date: '12/02/2026',
    bp: '127',
    temp: '98',
    hr: '78',
    rr: '89',
    wt: '75',
    ht: '5.9',
    bmi: '23.08'
  },
  {
    id: 15,
    date: '29/01/2026',
    bp: '122',
    temp: '99',
    hr: '73',
    rr: '84',
    wt: '73',
    ht: '5.8',
    bmi: '22.47'
  }
];

export const vitalSignColumns = [
  { field: 'date', headerName: 'DATE', width: '11%' },
  { field: 'bp', headerName: 'BP', width: '11%' },
  { field: 'temp', headerName: 'TEMP', width: '11%' },
  { field: 'hr', headerName: 'HR', width: '11%' },
  { field: 'rr', headerName: 'RR', width: '11%' },
  { field: 'wt', headerName: 'WT', width: '11%' },
  { field: 'ht', headerName: 'HT', width: '11%' },
  { field: 'bmi', headerName: 'BMI', width: '11%' }
];